export default "__VITE_ASSET__5de95c14__"